import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import type { PreviewContext } from '../preview.types';
import { getWelcomePreviewData } from '../preview-style.resolver';

@Component({
  selector: 'app-welcome-screen-preview',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './welcome-screen-preview.html',
  styleUrl: './welcome-screen-preview.scss',
})
export class WelcomeScreenPreviewComponent {
  @Input() context: PreviewContext | null = null;
  @Input() viewMode: 'web' | 'mobile' = 'web';
  @Output() startClick = new EventEmitter<void>();

  get data() {
    return getWelcomePreviewData(this.context);
  }

  onStartClick(): void {
    this.startClick.emit();
  }
}
